module.exports = __webpack_public_path__ + "static/cinema-app-59817ac5fd031e4f1638c57bf36899a0.png";